import React, { type Dispatch, type SetStateAction } from "react";

export type TAuthRole = { id: string; name: string };

export interface IAuthenticated {
  isAuthenticated: boolean;
  id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  token?: string;
  organization_root_id: string;
  roles?: TAuthRole[];
}
export type TAuthPayload = {
  changePasswordInNextLogin?: boolean;
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  token: string;
  organization_root_id: string;
  roles?: TAuthRole[];
};

export interface IAuthContextType {
  auth: IAuthenticated;
  setAuth: Dispatch<SetStateAction<IAuthenticated>>;
  handleAuthenticate: (userAuth: TAuthPayload, provider?: string) => boolean;
  logout: () => void;
}

const AuthContext = React.createContext<IAuthContextType | undefined>(
  undefined
);

export default AuthContext;
